<template>
    <div class="con-btn">
    <div class="content-caption dashed">
        <span>资产信息</span>
    </div>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="单品式管理" name="device"></el-tab-pane>
            <el-tab-pane label="批量式管理" name="durable"></el-tab-pane>
        </el-tabs>

        <div class="table-layout">
            <div v-show="activeName == 'device'">
                <div style="width: 100%;overflow-x: auto">
                    <el-form :model="scrapVoucher" ref="deviceInfo">
                        <table class="custom-tbl error-prompt">
                            <thead class="head">
                            <tr class="row">
                                <th width="180" style="text-align: left;">资产描述全称</th>
                                <th width="180" style="text-align: left;">名称</th>
                                <th width="150" style="text-align: left;">型号</th>
                                <th width="150" style="text-align: left;">规格</th>
                                <th width="250">系统编号</th>
                                <th width="250">商品标识码</th>
                                <th width="100" style="text-align: left;">分类</th>
                                <th width="100" style="text-align: left;">分类分组</th>
                                <th width="120" style="text-align: left;">品牌</th>
                                <th width="90" style="text-align: center;">入账方式</th>
                                <th width="100" style="text-align: center;">是否财务在账</th>
                                <th width="130">报废部门</th>
                                <th width="100">报废人</th>
                                <th width="160" style="text-align: left;">批次号</th>
                                <th width="160" style="text-align: left;">资产编号</th>
                                <th width="100" style="text-align: right;">报废</th>
                                <th width="80">单位</th>
                                <th width="120">报废原因</th>
                                <th width="120" style="text-align: left;">备注</th>
                                <!--<th width="100">清理费用</th>-->
                                <!--<th width="100">清理收入</th>-->
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(deviceItem, index) in scrapVoucher.deviceItems">
                                <td style="text-align: left;">{{deviceItem.title}}</td>
                                <td style="text-align: left;">{{deviceItem.name}}</td>
                                <td style="text-align: left;">{{deviceItem.model}}</td>
                                <td style="text-align: left;">{{deviceItem.fixedSpec}}</td>
                                <td>{{deviceItem.tmpNo}}</td>
                                <td>{{deviceItem.vendorUkno}}</td>
                                <td style="text-align: left;">{{deviceItem.catName}}</td>
                                <td style="text-align: left;">{{getGoodsCatDevcGroupName(deviceItem.catId)}}</td>
                                <td style="text-align: left;">{{deviceItem.brandName}}</td>
                                <td style="text-align: center;">{{acctEnterWayMap[deviceItem.acctEnterWay]}}</td>
                                <td style="text-align: center;">{{deviceItem.fiscalAcctFlag == 1 ? '是' : '否'}}</td>
                                <td>{{deviceItem.departName}}</td>
                                <td>{{deviceItem.staffName}}</td>
                                <td style="text-align: left;">{{deviceItem.batchNo}}</td>
                                <td style="text-align: left;">{{deviceItem.innerCode}}</td>
                                <td style="text-align: right;">{{deviceItem.quantity}}</td>
                                <td>{{deviceItem.theUnit}}</td>
                                <td style="text-align: left;">
                                    <el-select v-model="deviceItem.scrapCause" placeholder="请选择" disabled>
                                        <el-option v-for="item in devcScrapCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                                <td style="text-align: left;">
                                    <el-input class="textarea-value" type="textarea" disabled v-model="deviceItem.memo"></el-input>
                                </td>
                                <!--<td style="text-align: left;">-->
                                    <!--<el-form-item :prop="'deviceItems.' + index + '.theFee'" :rules="{validator: inputTheFee, trigger: 'blur'}">-->
                                        <!--<el-input class="input-content-left" type="text" v-model="deviceItem.theFee"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</td>-->
                                <!--<td style="text-align: left;">-->
                                    <!--<el-form-item :prop="'deviceItems.' + index + '.theInc'" :rules="{validator: inputTheInc, trigger: 'blur'}">-->
                                        <!--<el-input class="input-content-left" type="text" v-model="deviceItem.theInc"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</td>-->
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr v-if="scrapVoucher.deviceItems == null">
                                <td colspan="15" style="text-align: center; line-height: 40px;">
                                    <span class="font-gray3">暂无数据</span>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </el-form>
                </div>
            </div>
            <div v-show="activeName == 'durable'">
                <div style="width: 100%;overflow-x: auto">
                <el-form :model="scrapVoucher" ref="durableInfo">

                        <table class="custom-tbl error-prompt">
                            <thead class="head">
                            <tr class="row">
                                <th width="180" style="text-align: left;">资产描述全称</th>
                                <th width="180" style="text-align: left;">名称</th>
                                <th width="150" style="text-align: left;">型号</th>
                                <th width="150" style="text-align: left;">规格</th>
                                <th width="100" style="text-align: left;">分类</th>
                                <th width="100" style="text-align: left;">分类分组</th>
                                <th width="150" style="text-align: left;">品牌</th>
                                <th width="90" style="text-align: center;">入账方式</th>
                                <th width="130">报废部门</th>
                                <th width="100">报废人</th>
                                <th width="160" style="text-align: left;">批次号</th>
                                <th width="160" style="text-align: left;">资产编号</th>
                                <th width="100" style="text-align: right;">在库数量</th>
                                <th width="100" style="text-align: right;">财务在账数量</th>
                                <th width="100" style="text-align: right;">可报废数量</th>
                                <th width="100" style="text-align: right;">报废数量</th>
                                <th width="80">单位</th>
                                <th width="120">报废原因</th>
                                <th width="120" style="text-align: left;">备注</th>
                                <!--<th width="100">清理费用</th>-->
                                <!--<th width="100">清理收入</th>-->
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(durableItem, index) in scrapVoucher.durableItems">
                                <td style="text-align: left;">{{durableItem.title}}</td>
                                <td style="text-align: left;">{{durableItem.name}}</td>
                                <td style="text-align: left;">{{durableItem.model}}</td>
                                <td style="text-align: left;">{{durableItem.fixedSpec}}</td>
                                <td style="text-align: left;">{{durableItem.catName}}</td>
                                <td style="text-align: left;">{{getGoodsCatDevcGroupName(durableItem.catId)}}</td>
                                <td style="text-align: left;">{{durableItem.brandName}}</td>
                                <td style="text-align: center;">{{acctEnterWayMap[durableItem.acctEnterWay]}}</td>
                                <td>{{durableItem.departName}}</td>
                                <td>{{durableItem.staffName}}</td>
                                <td style="text-align: left;">{{durableItem.batchNo}}</td>
                                <td style="text-align: left;">{{durableItem.innerCode}}</td>
                                <td style="text-align: right;">{{durableItem.inStkQuantity}}</td>
                                <td style="text-align: right;">{{durableItem.fiscalQuantity}}</td>
                                <td style="text-align: right;">
                                    <span>{{durableItem.inStkQuantity < (durableItem.fiscalQuantity - durableItem.quantity) ? durableItem.inStkQuantity : (durableItem.fiscalQuantity - durableItem.quantity)}}</span>
                                </td>
                                <td style="text-align: right;">{{durableItem.quantity}}</td>
                                <td>{{durableItem.theUnit}}</td>
                                <td style="text-align: left;">
                                    <el-select v-model="durableItem.scrapCause" placeholder="请选择" disabled>
                                        <el-option v-for="item in devcScrapCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                    </el-select>
                                </td>
                                <td style="text-align: left;">
                                    <el-input class="textarea-value" type="textarea" disabled v-model="durableItem.memo"></el-input>
                                </td>
                                <!--<td style="text-align: left;">-->
                                    <!--<el-form-item :prop="'durableItems.' + index + '.theFee'" :rules="{validator: inputTheFee, trigger: 'blur'}">-->
                                        <!--<el-input class="input-content-left" type="text" v-model="durableItem.theFee"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</td>-->
                                <!--<td style="text-align: left;">-->
                                    <!--<el-form-item :prop="'durableItems.' + index + '.theInc'" :rules="{validator: inputTheInc, trigger: 'blur'}">-->
                                        <!--<el-input class="input-content-left" type="text" v-model="durableItem.theInc"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</td>-->
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr v-if="scrapVoucher.durableItems == null">
                                <td colspan="16" style="text-align: center; line-height: 40px;">
                                    <span class="font-gray3">暂无数据</span>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                </el-form>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import assetVchrApi from "../../api/assetVchr";
    import {getDevcGroupNameByCatId} from "../index";

    export default {
        name: "swb-shop-device-scrap-item-view",
        props: {
            id: {
                type: Number,
                default: null
            },
            oldScrapVoucher: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                scrapVoucher: {
                    theDate: new Date(),
                    warehouseId: null,
                    deviceItems: [],
                    durableItems: [],
                },
                activeName: "device",
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                devcScrapCauseList: getEnumList("devcScrapCause"),
            }
        },
        created: function () {
            if(!Utils.isNoB(this.oldScrapVoucher) && !Utils.isNoB(this.oldScrapVoucher.id)) {
                this.scrapVoucher = Utils.merge({}, this.oldScrapVoucher);
                let deviceItems = this.scrapVoucher.deviceItems;
                let durableItems = this.scrapVoucher.durableItems;
                //
                if(deviceItems != null || deviceItems.length > 0) {
                    this.activeName = "device";
                }else if(durableItems != null || durableItems.length > 0){
                    this.activeName = "durable";
                }
            }else {
                this.getShopDeviceScrapVoucherInfo();
            }
        },
        methods: {
            // 额外费用校验
            inputTheFee: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 额外费用校验
            inputTheInc: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            getShopDeviceScrapVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                assetVchrApi.getShopDeviceScrapVoucherById(postData, function (result) {
                    if(result.type == "info") {
                        let scrapVoucher = result.data;
                        //
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                        //
                        let deviceItems = scrapVoucher.deviceItems;
                        let durableItems = scrapVoucher.durableItems;
                        //
                        if(deviceItems != null || deviceItems.length > 0) {
                            self.activeName = "device";
                        }else if(durableItems != null || durableItems.length > 0){
                            self.activeName = "durable";
                        }

                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.data = self.scrapVoucher;
                return result;
            },
        }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/compo/scrapVoucher/ShopDeviceScrapItemView.vue